import allCountries from './CountriesAll';

let getCountries = (type) => {
	if (type === 'zh') {
		let China_index = -1;
		allCountries.map((country, index) => {
			if (country.code === 43) {
				China_index = index;
			}
		});
		const China = allCountries[China_index];
		allCountries.splice(China_index, 1);
		allCountries.unshift(China);
		return allCountries;
	} else if (type === 'en') {
		let Korea_index = -1;
		allCountries.map((country, index) => {
			if (country.code === 114) {
				Korea_index = index;
			}
		});
		const Korea = allCountries[Korea_index];
		allCountries.splice(Korea_index, 1);
		allCountries.unshift(Korea);
		return allCountries;
	} else {
		return allCountries;
	}
};
export default getCountries;